import {CategoryIcon} from '@/components/category-icon';
/** A round avatar for list charts: the category's icon in its color, or the name's initials on a dark circle. */
export function ListAvatar({name,icon,color}:{name:string;icon:string|null;color:string|null}){
 if(icon)return <CategoryIcon round icon={icon} color={color}/>;
 const initials=name.split(/\s+/).filter(Boolean).slice(0,2).map(w=>w[0]!.toUpperCase()).join('')||'?';
 return <span aria-hidden="true" className="inline-grid size-7 shrink-0 place-items-center rounded-full bg-foreground text-[0.65rem] font-medium text-background">{initials}</span>;
}
